// The small Markdown subset free text is shown with, so notes read as lists rather than one long
// line: paragraphs and line breaks, "- " bullets (also "* " and "• "), **bold**, and links
// ([label](https://…) or a bare https://…). Nothing else is interpreted; it's never HTML.

export type Inline =
  | { kind: "text"; text: string }
  | { kind: "bold"; text: string }
  | { kind: "link"; text: string; url: string };

// A paragraph's lines, each a run of inline pieces; or a list's items.
export type Block = { kind: "paragraph"; lines: Inline[][] } | { kind: "list"; items: Inline[][] };

const BULLET = /^\s*[-*•]\s+/;
const INLINE = /\*\*(.+?)\*\*|\[([^\]\n]+)\]\((https?:\/\/[^\s)]+)\)|(https?:\/\/[^\s<>()]*[^\s<>().,;:!?'"])/g;

export function inline(text: string): Inline[] {
  const out: Inline[] = [];
  let at = 0;
  for (const m of text.matchAll(INLINE)) {
    const index = m.index ?? 0;
    if (index > at) out.push({ kind: "text", text: text.slice(at, index) });
    if (m[1] !== undefined) out.push({ kind: "bold", text: m[1] });
    else if (m[2] !== undefined && m[3] !== undefined) out.push({ kind: "link", text: m[2], url: m[3] });
    else if (m[4] !== undefined) out.push({ kind: "link", text: m[4], url: m[4] });
    at = index + m[0].length;
  }
  if (at < text.length) out.push({ kind: "text", text: text.slice(at) });
  return out;
}

export function blocks(text: string): Block[] {
  const out: Block[] = [];
  let current: Block | null = null;
  for (const raw of text.replace(/\r\n?/g, "\n").split("\n")) {
    const line = raw.trimEnd();
    if (line.trim() === "") {
      current = null;
      continue;
    }
    const bullet = BULLET.test(line);
    const kind = bullet ? "list" : "paragraph";
    const block: Block =
      current && current.kind === kind ? current : kind === "list" ? { kind, items: [] } : { kind, lines: [] };
    if (block !== current) {
      out.push(block);
      current = block;
    }
    if (block.kind === "list") block.items.push(inline(line.replace(BULLET, "")));
    else block.lines.push(inline(line.trim()));
  }
  return out;
}
